const setActiveTab = (container, target) => {
  const tabs = Array.from(container.querySelectorAll(".js-production-tab"));
  const panels = Array.from(container.querySelectorAll(".js-production-panel"));

  tabs.forEach((tab) => {
    const isActive = tab.dataset.tab === target;
    tab.setAttribute("aria-selected", isActive ? "true" : "false");
    tab.classList.toggle("is-active", isActive);
  });

  panels.forEach((panel) => {
    const isActive = panel.dataset.tab === target;
    panel.classList.toggle("is-active", isActive);
    panel.removeAttribute("hidden");
  });
};

export const initProductionTabs = () => {
  const containers = Array.from(document.querySelectorAll(".js-production-tabs"));
  if (containers.length === 0) {
    return;
  }

  containers.forEach((container) => {
    const tabs = Array.from(container.querySelectorAll(".js-production-tab"));
    if (tabs.length === 0) {
      return;
    }

    const defaultTab = container.dataset.default || tabs[0].dataset.tab;
    setActiveTab(container, defaultTab);

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        setActiveTab(container, tab.dataset.tab);
        let el = container.parentElement;
        while (el) {
          if (el.scrollHeight > el.clientHeight) {
            el.scrollTop = 0;
          }
          el = el.parentElement;
        }
      });
    });
  });
};
